import React from 'react';

import { PvmLink } from '@app/constants/url.constants';
import { Button, ButtonVariant, ActionMode } from '@app/components/Button/Button';

export const PersonalManager: React.FC = () => (
	<div className="personal-manager">
		<h1 className="font-family_primary font-weight_bold text-size_hard-large text-header__primary">
			<b className="text-uppercase">Meet Our</b>
			<span className="font-family_decorative font-weight_light text-header__highlight"> Personal </span>
			<b className="text-uppercase"> Vacation </b>
			<span className="font-family_decorative font-weight_light text-header__highlight">Managers</span>
		</h1>
		<div className="personal-manager__container text-size_medium">
			<img
				className="personal-manager__container__cover"
				src="/static/media/managers.a0f1732fed1abc5b362e.png"
				alt=""
			/>
			<div className="personal-manager__container__text">
				<p>Did you know that our sales team has over a 95% positive rating on customer satisfaction surveys?</p>
				<p>
					Learn more about our Personal Vacation Managers' travel industry certifications, experience and education.
				</p>
			</div>

			<Button
				variant={ButtonVariant.Filled}
				link={PvmLink}
				action={ActionMode.InternalLink}
			>
				Get to Know Them
			</Button>
		</div>
	</div>
);
